import { createFileRoute } from '@tanstack/react-router';
import { BioScanPage } from '../components/scan/BioScanPage.tsx';

export const Route = createFileRoute('/_app/scan/bioscan')({
  component: BioScanPage,
});
